<template>
  <div>
    <div class="wrap">
      <img class="banner" mode="widthFix" style="height: 514px" src="https://ysh-cdn.kaidicloud.com/test/organization/enter_h5_bg2.png" />
      <div class="form" style="top: 278px; background-image: url(https://ysh-cdn.kaidicloud.com/test/organization/enter_h5_bg5.png); background-position: center center; background-size: cover">
        <div class="cell">
          <div class="cell-title">
            转介绍商协会
            <img class="required" src="https://ysh-cdn.kaidicloud.com/test/organization/reqired-icon.png" />
          </div>

          <div style="display: flex">
            <input class="cell-input" placeholder="请输入" placeholder-class="cell-placeholder" v-model="name" />
          </div>
        </div>

        <div class="cell">
          <div class="cell-title">
            转介绍人名称
            <img class="required" src="https://ysh-cdn.kaidicloud.com/test/organization/reqired-icon.png" />
          </div>
          <div style="display: flex">
            <input class="cell-input" placeholder="请输入" placeholder-class="cell-placeholder" v-model="contactName" />
          </div>
        </div>
        <div class="cell">
          <div class="cell-title">
            联系人手机号
            <img class="required" src="https://ysh-cdn.kaidicloud.com/test/organization/reqired-icon.png" />
          </div>
          <div style="display: flex">
            <input class="cell-input" placeholder="请输入您的手机号码" placeholder-class="cell-placeholder" type="number" maxlength="11" v-model="contactPhone" />
          </div>
        </div>
      </div>
    </div>
    <img class="banner" mode="widthFix" src="https://ysh-cdn.kaidicloud.com/test/organization/enter_h5_bg3.png"  @click="phone"/>
    <img class="banner" mode="widthFix" src="https://ysh-cdn.kaidicloud.com/test/organization/enter_h5_bg4.png">
    <div class="footer">
      <img class="footer-bg" src="https://ysh-cdn.kaidicloud.com/test/organization/enter-fast-btn-bg.png" />
      <img class="footer-btn" src="https://ysh-cdn.kaidicloud.com/test/organization/enter-fast-btn.png" @click="onSure" />
      <div class="footer-text" @click="onPrivacyAgreement" >隐私协议</div>
    </div>
  </div>
</template>

<script>
import { postIntroduceInfo, getWxLink,postWxId } from '@/api/data'

import Vue from 'vue'
import { Toast } from 'vant'

Vue.use(Toast)

export default {
  data() {
    return {
      name: '',
      contactName: '',
      contactPhone: '',
      url: '',
      gdt_vid: '',
    }
  },
  created() {},
  async mounted() {
    this.gdt_vid = this.$route.query.gdt_vid || ''

    if (this.gdt_vid) {
        postWxId(this.gdt_vid)
    }

    const res = await getWxLink('pages/skip/index', this.gdt_vid)
    if (res.data.state !== 1) return
    this.url = res.data.data.url
  },
  methods: {
    async onSure() {
      if (!this.name) {
        Toast('请输入转介绍商协会')
        return
      }
      if (!this.contactName) {
        Toast('请输入转介绍人名称')
        return
      }
      if (!this.contactPhone) {
        Toast('请输入您的手机号码')
        return
      }

      const res = await postIntroduceInfo(this.contactName, this.contactPhone, this.name,'h5')
      
      window.location.href = this.url
    },

    onPrivacyAgreement() {
        window.location.href = "https://h.kaidicloud.com/privacyPolicy.html"
    },

    phone() { 
      window.location.href = "tel:13533072359"
    }

  },
}
</script>

<style lang="less" scoped>
.banner {
  display: block;
  width: 100%;
}

.wrap {
  width: 100%;
  position: relative;
}

.wrap .form {
  position: absolute;
  left: 50%;
  transform: translate(-50%);
  width: 686px;
  border-radius: 16px;
}

.wrap .introduce {
  width: 100%;
  position: absolute;
  top: 1110px;
  padding: 0 16px 0 6px;
}

.wrap .introduce .introduce-text {
  position: absolute;
  left: 184px;
  top: 58px;
  font-size: 32px;
  font-family: Alibaba-PuHuiTi-B, Alibaba-PuHuiTi;
  color: #f94418;
  line-height: 24px;
  font-weight: bold;
  text-shadow: 0px 6px 24px rgba(249, 68, 24, 0.22);
}

.wrap .introduce .introduce-btn {
  position: absolute;
  width: 220px;
  left: 488px;
  top: 20px;
}

.cell {
  position: relative;
  padding: 24px;
}

.cell .cell-title {
  font-size: 32px;
  color: #333333;
  height: 48px;
  line-height: 48px;
  display: flex;
  align-items: center;
  margin-bottom: 8px;
}

.cell .required {
  width: 16px;
  height: 16px;
  margin-left: 8px;
}

.cell .cell-input {
  width: 100%;
  font-size: 28px;
  height: 44px;
  line-height: 44px;
  color: #222;
  border: none;
  background-color: transparent;
}

.cell .cell-placeholder {
  font-size: 28px;
  color: #999;
}

.footer {
  position: fixed;
  left: 0;
  bottom: -20px;
  width: 100%;
  height: 230px;
}

.footer-bg {
  width: 100%;
  height: 100%;
}

.footer-btn {
  position: absolute;
  left: 50%;
  top: 8px;
  transform: translate(-50%);
  width: 502px;
  height: 118px;
}

.footer-text {
  position: absolute;
  left: 50%;
  top: 140px;
  transform: translate(-50%);
  font-size: 28px;
  color: #fff;
}
</style>